<header class="site-header py-1">
  <div class="px-3 py-2">
    <div class="container">
      <div class="d-flex flex-wrap align-items-center justify-content-center">

        <ul class="nav col-12 col-lg-auto my-2 justify-content-center my-md-0 text-small">
          <li>
            <a routerLink="/" class="nav-link text-secondary">
              <img class="bi d-block mx-auto mb-1" width="96" height="24" src="assets/bars.png">

            NGX WaveSurfer
            </a>
          </li>
          <li>
            <a routerLink="ngx-component" class="nav-link">
              <img class="bi d-block mx-auto mb-1" width="24" height="24" src="assets/component.png">              Component
            </a>
          </li>
          <li>
            <a routerLink="ngx-service" class="nav-link">
              <img class="bi d-block mx-auto mb-1" width="24" height="24" src="assets/service.png">
            Service
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</header>

<h1 class="fw-light text-center py-5">Angular WaveSurfer</h1>

<div class="container">
  <router-outlet></router-outlet>
</div>
